<template>
    <section id="one-performer">
        <div class="secondary-heading text-center">ESSENS TURKEY 2026</div>
        <h1 class="text-center mb-5"> Instagram Reels </h1>
        <div id="reels-container" class="container-fluid container-xxl px-5 position-relative">
            <div class="row">
                <iframe src="https://cdn.lightwidget.com/widgets/905809ac1fc258228cf99cb04b5ecdd6.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>
            </div>
        </div>
    </section>
</template>

<style>

    #one-performer {
        background-color: white;
    } 


    /* .swiper-slide {
        background-color: rgba(0, 0, 0, 0.5);
        text-align: center;
    } */

    
    .swiper-button-next, .swiper-button-prev {
        top: calc(50% + 21px);
        z-index: 1;
        background: none !important;
    }

    .swiper-button-next {
        right: 5px;
    }
    .swiper-button-prev {
        left: 5px;
    }
    .swiper-button-next:after, .swiper-button-prev:after {
        color: var(--secondary);
    }

    /* @media (max-width: 1399px) {
        .swiper-button-next {
            right: 5px;
        }
        .swiper-button-prev {
            left: 5px;
        }
    } */
</style>